export const IdentifiedModelFields = `id`;
